import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle, faLink } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';
import { scrollToTop } from '@/lib/utilsUI';

/**
 * AmbassadorsList - Componente para mostrar lista de embajadores
 * @param {Object} props
 * @param {Array} props.ambassadors - Array de embajadores con estructura: { usuarioUid, nombre, apellido, imgPerfil, referralCode, linkUid }
 * @returns {JSX.Element}
 */
export default function AmbassadorsList({ ambassadors = [] }) {
  if (!ambassadors || ambassadors.length === 0) {
    return (
      <div className="text-center text-gray-400 py-4">
        No hay embajadores disponibles
      </div>
    );
  }

  return (
    <div className="flex flex-col justify-center items-start sm:grid sm:grid-cols-2 sm:gap-4 w-full">
      {ambassadors.map((ambassador, index) => (
        <Link
          key={ambassador.usuarioUid || `ambassador-${index}`}
          className="sm:bg-aw-bluedark/40 rounded-lg p-4 flex items-center gap-3 hover:bg-aw-bluegray/30 transition-colors duration-200"
          to={`/usuario/${ambassador.usuarioUid}`}
          onClick={scrollToTop}
        >
          {/* Imagen de perfil */}
          <div className="flex-shrink-0">
            {ambassador.imgPerfil ? (
              <img
                src={ambassador.imgPerfil}
                alt={`${ambassador.nombre} ${ambassador.apellido}`}
                className="w-16 h-16 rounded-full object-cover border-2 border-aw-green"
              />
            ) : (
              <div className="w-16 h-16 rounded-full bg-aw-bluedark flex items-center justify-center border-2 border-aw-green">
                <FontAwesomeIcon
                  icon={faUserCircle}
                  className="text-aw-green text-3xl"
                />
              </div>
            )}
          </div>

          {/* Información del embajador */}
          <div className="flex-1 min-w-0">
            <h4 className="text-white font-semibold text-sm truncate">
              {ambassador.nombre} {ambassador.apellido}
            </h4>
            {ambassador.referralCode && (
              <div className="flex items-center gap-1 mt-1">
                <FontAwesomeIcon
                  icon={faLink}
                  className="text-aw-green text-xs"
                />
                <span className="text-aw-green text-xs font-medium">
                  Embajador Oficial
                </span>
              </div>
            )}
          </div>
        </Link>
      ))}
    </div>
  );
}
